import './SwitchToCompany.scss'

import PropTypes from 'prop-types'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useClickAway } from 'react-use'

import { switchToCompanyTab } from '../../../../../actions/actions'

export default function SwitchToCompany({ containerWidth }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [tooltipVisible, setTooltipVisible] = useState(false)
  const tooltipRef = useRef(null)

  const openTooltip = () => setTooltipVisible(true)
  const closeTooltip = () => setTooltipVisible(false)

  const handleOkClick = () => {
    dispatch(switchToCompanyTab())
    closeTooltip()
    if (window?.SSO) window.SSO.signOut()
  }

  useClickAway(tooltipRef, closeTooltip)

  return (
    <div className="switch-to-company">
      <button className="switch-to-company-button" onClick={openTooltip}>
        {t('clubOne.switchToCompanyCustomer.title')}
      </button>
      {tooltipVisible && (
        <div className="switch-to-company-tooltip" ref={tooltipRef} style={{ width: `${containerWidth}px` }}>
          <div className="text">{t('clubOne.switchToCompanyCustomer.warning')}</div>
          <div className="buttons">
            <button onClick={closeTooltip}>{t('common.cancel')}</button>
            <button className="accent" onClick={handleOkClick}>
              {t('common.ok')}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}

SwitchToCompany.propTypes = {
  containerWidth: PropTypes.number.isRequired
}
